import {
  Button,
  Modal,
  ModalContent,
  ModalFooter,
  Select,
  SelectOption,
} from '@deque/cauldron-react'
import { navigate } from 'gatsby'
import React from 'react'
import { useGatsbyPageContext } from '../../context/GatsbyPageContext'
import './VersionSelectModal.scss'
import semverSort from '../../lib/semver-sort'
import { useTranslation } from 'react-i18next'

type VersionSelectModalProps = {
  show: boolean
  onClose(): void
}

export function VersionSelectModal(props: VersionSelectModalProps) {
  const { version, productVersions, productId, locale } = useGatsbyPageContext()
  const [selectedVersion, setSelectedVersion] = React.useState(version)
  const { t } = useTranslation()
  const versionOptions: SelectOption[] = semverSort(productVersions)
    .reverse()
    .map((version: string) => ({ key: version, value: version }))

  return (
    <Modal
      show={props.show}
      heading={<div>{t('selectProductVersion')}</div>}
      onClose={() => props.onClose()}
    >
      <ModalContent>
        <Select
          label={t('productVersion')}
          value={selectedVersion}
          onChange={(e) => setSelectedVersion(e.target.value)}
          options={versionOptions}
        />
      </ModalContent>
      <ModalFooter>
        <Button
          onClick={() => {
            props.onClose()
            navigate(`/${productId}/${selectedVersion}/${locale}`)
          }}
        >
          {t('apply')}
        </Button>
        <Button variant="secondary" onClick={() => props.onClose()}>
          {t('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
